module.exports = __webpack_public_path__ + "d30f87fd2225f11b85cbc0833333feb6.png";